import './vendor.scss';

/**
 *  Polyfills for ES6
 */

import 'core-js/es/promise';
import 'core-js/es/array/includes';
import 'core-js/es/object/assign';
import 'core-js/es/string/trim';
import 'core-js/es/array/at';

/**
 *  Angular dependencies
 */

import angular from 'angular';
import ngAnimate from 'angular-animate';
import ngResource from 'angular-resource';
import ngTouch from 'angular-touch';
import ngSanitise from 'angular-sanitize';
import { UI_ROUTER_REACT_HYBRID } from '@uirouter/react-hybrid';
import ngTranslate from 'angular-translate';
import { name as ngSpinner } from 'angular-spinner';
import ngStrapBase from 'vendor/angular-strap-base';
import lbServices from 'vendor/lb-services';
import ngScroll from 'vendor/angular-scroll';

import '@uirouter/angularjs/lib/legacy/stateEvents';
import 'ng-notifications-bar';
import 'doxyme-angular-validate/angular-validate';
import 'angulartics';
import 'angulartics/src/angulartics-intercom';
import 'angular-loggly-logger/angular-loggly-logger';
import '@iamadamjowett/angular-click-outside';

export default angular.module('doxy.vendors', [
  ngAnimate,
  ngResource,
  ngTouch,
  ngSanitise,
  'ui.router',
  UI_ROUTER_REACT_HYBRID,
  ngTranslate,
  ngSpinner,
  ngStrapBase,
  ngScroll,
  lbServices,

  'ui.router.state.events',
  'ngNotificationsBar',
  'validation',
  'angulartics',
  'angulartics.intercom',
  'logglyLogger.logger',
  'angular-click-outside',
]).name;

/**
 * Other global vendors
 */

import loadScript from 'tiny-script-loader/loadScriptPromised';

window.loadScript = loadScript;
